import { stringify } from 'query-string';
export class Utils {
  static createUrlQuery(params: any) {
    if (!params) {
        return "";
    }

    let page;
    let perPage;
    let field;
    let order;
    let query: any = {};
    if (params.pagination) {
         page = params.pagination.page;
         perPage =  params.pagination.perPage;
        //  query.range = JSON.stringify([
        //     page,
        //     perPage,
        // ]);
        query.page = page;
        query.size = perPage;
    }

    if (params.sort) {
        field = params.sort.field;
        order = params.sort.order;
        if (field && order) {
            query.sort = JSON.stringify([field, order]);
        // } else {
        //     query.sort = JSON.stringify(['id', 'ASC']);
        }
    }
    // if (!params.filter) {
    //     params.filter = {};
    // }
    // if (Array.isArray(params.ids)) {
    //     params.filter.id = params.ids;
    // }

    // if (params.filter) {
    //     query.filter = JSON.stringify(params.filter);
    // }
    //
    // console.log(query, stringify(query));
    return stringify(query);
}
}
